import React from 'react';
import Resturant from './Components/Basics/Resturant';
// import UseState from './Components/Hooks/useState'
// import  UseEffect from './Components/Hooks/useEffect';
// import UseReducer from './Components/Hooks/UseReducer';
// import Todo from './Components/todoList/Todo.js';
// import WeatherApp from './Components/WeatherApp/WeatherApp'


const App = () => {
  return (
    <>
 <Resturant/>

{/* <WeatherApp/> */}
   
    </>
  )
}

export default App;
